import React, { forwardRef } from "react";
import { Switch, SwitchRootProps } from "@ark-ui/react";
import { aromaToggleSwitch } from "@zenchef/styled-system/recipes";
import Icon from "../Icon/Icon";

export type ToggleSwitchProps = Omit<
  SwitchRootProps,
  "checked" | "onChange"
> & {
  onChange: (checked: boolean) => void;
  checked: SwitchRootProps["checked"] | null;
};

const ToggleSwitch = forwardRef(
  (
    { disabled, checked, onChange, children, ...props }: ToggleSwitchProps,
    ref: React.Ref<HTMLLabelElement>,
  ) => {
    const classes = aromaToggleSwitch();
    return (
      <Switch.Root
        onCheckedChange={({ checked }) => {
          onChange(checked);
        }}
        className={classes}
        disabled={disabled}
        checked={checked ?? undefined}
        ref={ref}
        {...props}
      >
        <Switch.Control
          data-indeterminate={
            checked === undefined || checked === null ? true : undefined
          }
        >
          <Switch.Thumb>
            <Icon name="check-01" />
          </Switch.Thumb>
        </Switch.Control>
        {children ? <Switch.Label>{children}</Switch.Label> : null}
        <Switch.HiddenInput />
      </Switch.Root>
    );
  },
);

export default ToggleSwitch;
